<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">设备类型</div>
      <!-- <el-select v-model="value" filterable placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select> -->
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true">
          <el-form-item label="设备类型">
            <el-input
              v-model="equipmentTypeName"
              clearable
              @clear="getBiEquipmentType()"
              placeholder="请输入设备类型"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getBiEquipmentType()"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-form :inline="true">
          <el-form-item>
            <el-button
              @click="
                addVisible = true
                isequipmentTypeUpdate = false
              "
            >
              新增
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="onExport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        max-height="600"
        border
        style="width: 100%"
        :header-cell-style="{'text-align': 'center'}"
        :cell-style="{'text-align': 'center'}"
      >
        <el-table-column
          type="index"
          label="编号"
          width="80px"
        ></el-table-column>
        <el-table-column
          prop="equipmentTypeName"
          min-width="150px"
          label="设备类型"
        ></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          min-width="150px"
        ></el-table-column>
        <el-table-column
          prop="mark"
          label="设备类型解释"
          min-width="150px"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" width="120px" fixed="right">
          <template #default="scope">
            <div>
              <el-button type="text" @click="update(scope.row)">修改</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 新增&修改设备类型 -->
    <el-dialog
      :visible.sync="addVisible"
      :modal-append-to-body="false"
      width="65%"
      @close="cancelDialog()"
      :close-on-click-modal="false"
    >
      <!-- title -->
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">设备类型</div>
        </div>
      </span>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        style="text-align: left"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="设备类型" prop="equipmentTypeName">
              <el-input
                class="xq-input"
                v-model="ruleForm.equipmentTypeName"
                placeholder="请输入设备类型"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="设备类型解释" prop="mark">
              <el-input
                type="textarea"
                :autosize="{minRows: 6, maxRows: 8}"
                maxlength="15000"
                show-word-limit
                v-model="ruleForm.mark"
                placeholder="请输入设备类型解释"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="备注" prop="remarks">
              <el-input
                type="textarea"
                :autosize="{minRows: 6, maxRows: 8}"
                maxlength="150"
                show-word-limit
                v-model="ruleForm.remarks"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="add_sure()">确 定</el-button>
        <el-button @click="cancelDialog()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'index',
  data() {
    return {
      isequipmentTypeUpdate: false,
      equipmentTypeName: '',
      ruleForm: {
        equipmentTypeName: '',
        mark: '',
        remarks: ''
      },
      rules: {
        equipmentTypeName: [
          {
            required: true,
            message: '请输入设备类型',
            trigger: 'blur'
          }
        ]
      },
      tableData: [],
      loading: false,
      // 分页器
      pagination: {
        pageSize: 10,
        pageNum: 1 //当前页数
      },
      total: 0,
      addVisible: false
    }
  },
  async mounted() {
    // 获取设备类型信息
    this.getBiEquipmentType()
  },
  methods: {
    // 取消按钮操作
    cancelDialog() {
      // 关闭校验
      this.$refs.ruleForm.resetFields()
      this.addVisible = false
    },
    // 新增设备类型
    add_sure() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let url = ''
          if (this.isequipmentTypeUpdate) {
            // 修改设备类型
            url = '/biEquipmentType/update'
          } else {
            delete this.ruleForm.equipmentTypeUuid
            // 新增设备类型
            url = '/biEquipmentType/save'
          }
          const res = await this.$api.sendPost(url, this.ruleForm)
          if (res.errcode == 0) {
            this.$message.success(res.errmsg)
            this.addVisible = false
            // 获取设备类型信息
            this.getBiEquipmentType()
          } else {
            this.$message.error(res.errmsg)
          }
        } else {
          return false
        }
      })
    },
    // 获取设备类型信息
    async getBiEquipmentType() {
      let data = {
        equipmentTypeName: this.equipmentTypeName,
        ...this.pagination
      }
      const res = await this.$api.sendPost(
        '/biEquipmentType/getBiEquipmentType',
        data
      )
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
        }
      }
      console.log('设备类型res>>>', res)
    },
    // 导出
    onExport() {
      axios({
        method: 'get',
        url: this.$config.host + '/biEquipmentType/export',
        params: {
          // equipmentTypeName: '设备类型', //设备类型名称
          isExportAll: true //true:导出所有，false:导出当前页 默认:false
          // pageNum: this.pagination.pageNum, //页数 默认:1
          // pageSize: this.pagination.pageSize //条数 默认:10
        },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          const link = document.createElement('a')
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
            // type: "application/pdf;charset=utf-8",  //.pdf
          })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '设备类型' + '.xls' //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 修改
    update(row) {
      this.isequipmentTypeUpdate = true
      const obj = JSON.parse(JSON.stringify(row))
      this.addVisible = true
      this.$nextTick(() => {
        this.ruleForm.equipmentTypeName = obj.equipmentTypeName
        this.ruleForm.equipmentTypeUuid = obj.equipmentTypeUuid
        this.ruleForm.remarks = obj.remarks
        this.ruleForm.mark = obj.mark
      })
    },
    // 删除
    del(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          console.log(row)
          const res = await this.$api.sendGet('/biEquipmentType/delete', {
            biEquipmentTypeUuid: row.equipmentTypeUuid
          })
          if (res.errcode == 0) {
            this.$message.success(res.errmsg)
            // 获取设备类型信息
            this.getBiEquipmentType()
          } else {
            this.$message.error(res.errmsg)
          }
        })
        .catch(() => {
          this.$message.error('已取消操作')
        })
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.pagination.pageSize = val
      // console.log(val);
      // 获取设备类型信息
      this.getBiEquipmentType()
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      // console.log(val);
      // 获取设备类型信息
      this.getBiEquipmentType()
    }
  }
}
</script>

<style lang="scss" scoped>
.modul-content {
  width: 98%;

  .query-form {
    display: flex;
    justify-content: space-between;
  }
}
</style>
